export class MultipleFilesChosenException extends Error {
  constructor(message: string) {
    super(message);
  }
}
